"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Localize_1 = require("../../../gen-src/Localize");
var HelpWeb_1 = require("../../img/model-results/HelpWeb");
var styles = require("../../styles/ModelResultStyles");
var TestIds_1 = require("../../util/TestIds");
var Index_1 = require("../base/Index");
var NavigationContext_1 = require("../base/NavigationContext");
var ModelResultModelAccuracy_1 = require("./common/ModelResultModelAccuracy");
var ModelResultOutcomeDistribution_1 = require("./common/ModelResultOutcomeDistribution");
var ModelResultTopPredictors_1 = require("./common/ModelResultTopPredictors");
var ModelResultOverviewSection = function () {
    var refs = React.useContext(NavigationContext_1.NavigationContext);
    var setNavigationRef = function (node) {
        refs['MODEL_RESULT_OVERVIEW'] = node;
    };
    return (React.createElement("div", { ref: setNavigationRef, className: styles.OverviewContainer, "data-tb-test-id": TestIds_1.MODEL_RESULT_OVERVIEW_TEST_ID },
        React.createElement(Index_1.Card.List, { icon: React.createElement(HelpWeb_1.HelpWeb, null), title: Localize_1.Messages.modelReviewOverview(), indent: false },
            React.createElement(Index_1.Card, { hideBorder: true },
                React.createElement(ModelResultModelAccuracy_1.default, null)),
            React.createElement(Index_1.Card, { hideBorder: true },
                React.createElement(ModelResultOutcomeDistribution_1.default, null)),
            React.createElement(Index_1.Card, { hideBorder: true },
                React.createElement(ModelResultTopPredictors_1.default, null)))));
};
exports.default = ModelResultOverviewSection;
//# sourceMappingURL=ModelResultOverviewSection.js.map